export default __webpack_public_path__ + "static/banner_mobile-edff57d1e4eb7e66f6839188620153e4.svg";